
        var result = require("!!../../../../node_modules/css-loader/index.js!./training.shared.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/training/training.shared.css
// module id = 167
// module chunks = 0